import { render, staticRenderFns } from "./giftcard.vue?vue&type=template&id=4093eaea"
import script from "./giftcard.vue?vue&type=script&lang=js"
export * from "./giftcard.vue?vue&type=script&lang=js"
import style0 from "./giftcard.vue?vue&type=style&index=0&id=4093eaea&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports